<template>
  <div class="file" @click="$refs.input.click()">
    {{ this.name || $t("CHOOSE_FILE") }}
    <input @change="onChange" ref="input" class="input" type="file" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
    };
  },
  methods: {
    onChange(e) {
      const file = e.target.files[0];
      if (!file) {
        this.name = '';
        return;
      }

      this.name = file.name;
      const reader = new FileReader();
      reader.onload = (event) => {
        this.$emit('input', event.target.result.replace(/^.*,/, ''));
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style lang="scss" scoped>
.file {
  background: var(--tertiary-bg);
  border: 1px solid var(--tertiary-accent);
  border-radius: 2px;
  padding: 6px;
  margin-left: auto;
  flex: 0 0 150px;
  width: 150px;
  font-size: 14px;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.input {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  pointer-events: none;
}
</style>
